var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Layer 1",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22 16.53V21a.93.93 0 010 .24 1 1 0 01-1 .76H3a1 1 0 01-1-.88A1 1 0 012 21v-4.48a.95.95 0 011.89 0v3.55h16.23v-3.55a.95.95 0 011.61-.67 1 1 0 01.27.68z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.45 7l-4.64-4.65a1.15 1.15 0 00-.64-.35h-.33a1.05 1.05 0 00-.61.31L6.56 7a1.08 1.08 0 00-.32.78 1.1 1.1 0 001.88.78l2.79-2.79V16a1.11 1.11 0 001.1 1.1 1.09 1.09 0 00.78-.32 1.11 1.11 0 00.33-.78V5.76l2.78 2.79a1.12 1.12 0 001.57 0A1.13 1.13 0 0017.45 7z"
})));

export default SvgIconUpload;